import React, { useState, useEffect, useMemo } from "react";
import styled, { css } from "styled-components";

// components
import Text from "components/ui/Text";
import TextField from "components/ui/TextField";
import Button from "components/entrance/Button";
import EntranceTemplate from "components/entrance/entrance-template";

const ResetPwTemplate = ({
  title,
  buttonOnClick,
  infoTitle = false,
  infoText = false,
  inputValue,
  inputValueChange,
  onClickBack,
}) => {
  const [focused, setFocused] = useState([true, false]);
  const [inputValidation, setInputValidation] = useState([
    {
      text: "8자 이상 숫자와 영어를 포함해서 입력해주세요",
      color: "gray20",
    },
    {
      text: "",
      color: "gray20",
    },
  ]);
  const onFocus = (i) => {
    setFocused((previousValue) =>
      previousValue.map((v, idx) => (i === idx ? true : false))
    );
  };
  const onBlur = (i) => {
    setTimeout(() => {
      setFocused((previousValue) =>
        previousValue.map((v, idx) => (i === idx ? false : v))
      );
    }, 100);
  };

  useEffect(() => {
    return () => {
      setFocused([false, false]);
    };
  }, []);

  const isCheckPwValidation = useMemo(() => {
    const { passCode, passCodeConfirm } = inputValue;
    if (passCode.length > 7) {
      if (passCode.match(/[a-zA-Z]/g) && passCode.match(/[0-9]/g)) {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 0
              ? { ...value, text: "안전한 비밀번호입니다", color: "primary50" }
              : value
          )
        );
      } else {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 0
              ? {
                  ...value,
                  text: "8자 이상 숫자와 영어를 포함해서 입력해주세요",
                  color: "danger",
                }
              : value
          )
        );
        return false;
      }
    }
    if (passCode.length < 8) return false;

    if (passCodeConfirm.length >= 0) {
      if (passCode !== passCodeConfirm) {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 1
              ? {
                  ...value,
                  text: "비밀번호가 동일하지 않아요",
                  color: "danger",
                }
              : value
          )
        );
        return false;
      } else {
        setInputValidation((previousValue) =>
          previousValue.map((value, idx) =>
            idx === 1
              ? { ...value, text: "안전한 비밀번호입니다", color: "primary50" }
              : value
          )
        );
      }
    }

    return true;
  }, [inputValue]);

  const TopContent = useMemo(() => {
    return (
      <WrapperInput>
        <TextField
          pattern={false}
          type="passwordWithEye"
          maxLength="100"
          label="새 비밀번호"
          placeholder="새 비밀번호를 입력해주세요"
          value={inputValue.passCode}
          onChange={(e) => inputValueChange(e, "passCode")}
          autoFocus={focused[0]}
          focused={focused[0]}
          onFocus={() => onFocus(0)}
          onBlur={() => onBlur(0)}
          validation={inputValidation[0]}
          css={css`
            margin-bottom: 16px;
          `}
        />
        <TextField
          pattern={false}
          type="passwordWithEye"
          maxLength="100"
          label="새 비밀번호 확인"
          placeholder="새 비밀번호 다시 입력해주세요"
          value={inputValue.passCodeConfirm}
          onChange={(e) => inputValueChange(e, "passCodeConfirm")}
          autoFocus={focused[1]}
          focused={focused[1]}
          onFocus={() => onFocus(1)}
          onBlur={() => onBlur(1)}
          validation={inputValidation[1]}
        />
      </WrapperInput>
    );
  }, [focused, inputValue, inputValidation]);

  const BtmContent = useMemo(() => {
    return (
      <>
        {infoText && (
          <>
            <Text
              display="block"
              color="primary50"
              fontSize="16px"
              fontWeight="600"
              lineHeight="24px"
              css={css`
                margin-bottom: 4px;
              `}
            >
              {infoTitle}
            </Text>
            <Text color="gray80" fontSize="14px">
              {infoText}
            </Text>
          </>
        )}

        <Button
          disabled={!isCheckPwValidation}
          color={isCheckPwValidation ? "white" : "disable"}
          background={isCheckPwValidation ? "primary100" : "gray5"}
          onClick={isCheckPwValidation ? buttonOnClick : () => {}}
        >
          비밀번호 등록
        </Button>
      </>
    );
  }, [focused, inputValue, isCheckPwValidation]);

  return (
    <EntranceTemplate
      title={title}
      topContent={TopContent}
      btmContent={BtmContent}
      onClickBack={onClickBack}
    />
  );
};

const WrapperInput = styled.div`
  margin-top: 32px;
`;

export default ResetPwTemplate;
